<template>
    <div class="wrap">
        <form @submit.prevent="upload" style="display:flex;flex-direction: column;">
            <div class="upload">
                <input type="file" ref="uploadInput1" class="input">
                <span>linker</span>
                <el-input v-model="input1" placeholder="Please input"></el-input>
                <span>recligand</span>
            </div>
            <div class="upload">
                <input type="file" ref="uploadInput2" class="input">
                <span>receptor</span>
                <el-input v-model="input2" placeholder="Please input"></el-input>
                <span>e3ligand</span>
            </div>
            <div class="upload">
                <input type="file" ref="uploadInput3" class="input">
                <span>e3ligase</span>
                <el-input v-model="input3" placeholder="Please input"></el-input>
                <span>receptorChainName</span>
            </div>
            <div class="upload">
                <input type="file" ref="uploadInput4" class="input">
                <span>decoy_atom_list</span>
                <el-input v-model="input4" placeholder="Please input"></el-input>
                <span>e3ligaseChainName</span>
            </div>
            <div class="upload">
                <input type="file" ref="uploadInput5" class="input">
                <span>linker_atom_list</span>
                <el-input v-model="input5" placeholder="Please input"></el-input>
                <span>linker_receptor_atomName</span>
            </div>
            <div class="upload">
                <input type="file" ref="uploadInput6" class="input">
                <span>decoy_atom_delete</span>
                <el-input v-model="input6" placeholder="Please input"></el-input>
                <span>linker_e3ligase_atomName</span>
            </div>
            <div class="upload">
                <input type="file" ref="uploadInput7" class="input">
                <span>linker_atom_delete</span>
                <el-input v-model="input7" placeholder="Please input"></el-input>
                <span>decoy_receptor_atomName</span>
            </div>
            <div class="upload">
                <input type="text" class="input" style="border: none;background: none;">
                <span></span>
                <el-input v-model="input8" placeholder="Please input"></el-input>
                <span>decoy_e3ligase_atomName</span>
            </div>
            <div class="upload" style="border:none">
                <button style="width:230px;margin-top:20px">上传文件</button>
            </div>
        </form>
        <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
            <div>请保存好此id，下载文件时使用</div>
            <div style="margin-top:20px">{{ taskId }}
                <el-button class="tag-read" :data-clipboard-text="taskId" size="mini" @click="handleCopy">复制</el-button>
            </div>
        </el-dialog>
    </div>
</template>
  
<script>
import { upLoad } from '../api/api'
import Clipboard from 'clipboard'
export default {
    data() {
        return {
            dialogVisible: false,
            taskId: '',
            input1: '',
            input2: '',
            input3: '',
            input4: '',
            input5: '',
            input6: '',
            input7: '',
            input8: '',
        }
    },
    created() {

    },
    methods: {
        upload() {
            const formData = new FormData();
            formData.append('linker', this.$refs.uploadInput1.files[0])
            formData.append('receptor', this.$refs.uploadInput2.files[0])
            formData.append('e3ligase', this.$refs.uploadInput3.files[0])
            formData.append('decoy_atom_list', this.$refs.uploadInput4.files[0])
            formData.append('linker_atom_list', this.$refs.uploadInput5.files[0])
            formData.append('decoy_atom_delete', this.$refs.uploadInput6.files[0])
            formData.append('linker_atom_delete', this.$refs.uploadInput7.files[0])
            formData.append('recligand', this.input1)
            formData.append('e3ligand', this.input2)
            formData.append('recptor_chain name', this.input3)
            formData.append('e3ligase chain name', this.input4)
            formData.append('linker_receptor_atom name', this.input5)
            formData.append('linker e3ligase atom name', this.input6)
            formData.append('decoy receptor atom name', this.input7)
            formData.append('decoy_e3ligase atom name', this.input8)
            console.log(this.$refs.uploadInput1.files[0])
            console.log('formData', formData)
            upLoad(formData).then(res => {
                if (res.error) {
                    this.$message.error(res.error)
                } else {
                    this.taskId = res.task_id
                    this.dialogVisible = true
                }
            })
        },
        handleClose() {
            this.dialogVisible = false
        },
        handleCopy() {
            var clipboard = new Clipboard('.tag-read')
            clipboard.on('success', e => {
                this.$message.success('复制成功')
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                this.$message.warning('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        }
    }
}
</script>
<style lang="scss" scoped>
@media only screen and (max-width: 750px) {
    .input {
        margin: 10px;
        display: block;
        width: 68%;
    }

    span {
        font-size: 12px;
        margin-top: 10px;
    }

    .upload {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 20px;
        padding-bottom: 10px;
        border-bottom: 1px solid #d8d8d8;
    }

    /deep/.el-input__inner,
    .el-input {
        margin-top: 10px;
    }
}

@media only screen and (min-width: 751px) {
    .input {
        width: 360px;
        margin: 20px;
    }

    span {
        width: 200px;
        font-size: 16px;
        margin-left: 10px;
    }

    .upload {
        display: flex;
        align-items: center;
        justify-content: start;

        span:last-child {
            margin-left: 60px;
        }
    }

    /deep/.el-input__inner,
    .el-input {
        width: 400px;
    }
}
</style>